//src/mis/components/TableBasic.jsx
import * as React from 'react';
import { Button, Box, Grid, Typography, TextField, FormControl, InputLabel, Select, MenuItem, IconButton, InputAdornment } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { Search, Refresh } from '@mui/icons-material';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import {
  GridRowModes,
  DataGrid,
  GridToolbarExport, 
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
  GridCellModes,
  useGridApiRef,
} from '@mui/x-data-grid';
import {
  randomCreatedDate,
  randomTraderName,
  randomId,
  randomArrayItem,
} from '@mui/x-data-grid-generator';

import { useLocation, useNavigate } from "react-router-dom";
import { ReportOutlined } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { useState } from "react";
import Edit from '../pages/Edit';
import Add from '../pages/Add';

import env from "react-dotenv";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import SaveAltIcon from '@mui/icons-material/SaveAlt';

const initialRows = [
  
];

function EditToolbar(props) {
  const { setRows, setRowModesModel } = props;
  const navigate = useNavigate();
  const { selectedCellParams, cellMode, cellModesModel, setCellModesModel, handleExport, handleAddSuccess, handleEditSuccess, data, setFilteredData, handleRefresh} = props;
  const [searchQuery, setSearchQuery] = useState('');
  const user = useSelector((state) => state.user);
  // const [isAdmin, setIsAdmin] = useState(user?.role === 'Maintenance Admin' ? true : false);
  const [isAdmin, setIsAdmin] = useState(() => {
    if (!user || !user.department) return false; // Handle case where user or department is undefined
    const role = user.role?.toLowerCase();
    const department = user.department?.toLowerCase();
    // Check if user is Admin and department does not include Store or Supply or Others
    const isAdminRole = role === 'admin' && !department.includes('store') && !department.includes('supply') && !department.includes('others');
    
    // Check if user is Super Admin
    const isSuperAdminRole = role === 'super admin';
    return isAdminRole || isSuperAdminRole;
  });

  const [isAllowed, setIsAllowed] = useState(false);

  const location = useLocation();
  React.useEffect( () => {
    if(location.key === undefined || location.key === null || location.key === 'default'){
      navigate("/");   
    }
  }, [ location ] );

  const handleSaveOrEdit = () => {
    if (!selectedCellParams) {
      return;
    }
    const { id, field } = selectedCellParams;
    
    if (cellMode === 'edit') {      
        navigate(`../edit/${id}`, { replace: true })
    } else {
        navigate(`../edit/${id}`, { replace: true })
    }
  };

  const handleDelete = async () => {
    
    if (!selectedCellParams) {
        return;
      }
      const { id, field, dataId } = selectedCellParams;
      const rIndex = dataId;
    try {
      const res = await fetch(
        `${process.env.REACT_APP_MISBACKEND_URL}/deleteMaintenanceRecord/${rIndex}`,
        {
          method: "DELETE",
        }
      );
      navigate(0);
      navigate("../maintenanceHome/2");
     
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancel = () => {
    if (!selectedCellParams) {
      return;
    }
    const { id, field } = selectedCellParams;
    setCellModesModel({
      ...cellModesModel,
      [id]: {
        ...cellModesModel[id],
        [field]: { mode: GridCellModes.View, ignoreModifications: true },
      },
    });
  };

  const handleMouseDown = (event) => {
    // Keep the focus in the cell
    event.preventDefault();
  };

  const handleClick = () => {
    // const id = randomId();
    // setRows((oldRows) => [...oldRows, { id, name: '', age: '', isNew: true }]);
    // setRowModesModel((oldModel) => ({
    //   ...oldModel,
    //   [id]: { mode: GridRowModes.Edit, fieldToFocus: 'name' },
    // }));
  };

  const handleSearch = (query) => {
        setSearchQuery(query);
        const filtered = data.filter((row) => {
            return Object.values(row).some((field) =>
                field && field.toString().toLowerCase().includes(query.toLowerCase())
            );
        });
        setFilteredData(filtered);
    };

  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);

  return (
   
    <GridToolbarContainer>
      {isAdmin && ( 
        
           <div>
                <Button onClick={()=>setOpen(true)}>Add</Button>
                <Add open={open} onClose={() => setOpen(false)} onSuccess={handleAddSuccess}/>
            </div>
        )}
      {/* {isAdmin && ( 
        <Button color="primary" startIcon={<AddIcon />} href="../maintenanceHome/add" variant="outlined">
          Add
        </Button>  )} */}
      {/* {isAdmin && (<Button color="primary" startIcon={<EditIcon />}
          onClick={handleSaveOrEdit}
          onMouseDown={handleMouseDown}
          disabled={!selectedCellParams}
          variant="outlined"
        >
          {cellMode === 'edit' ? 'Edit' : 'Edit'}
        </Button>  )} */}
        {isAdmin && 
        (  
          <>
           <Button color="primary" startIcon={<EditIcon />}
          onClick={()=>{setOpenEdit(true)}}
          onMouseDown={handleMouseDown}
          disabled={!selectedCellParams}
          >
          Edit
          </Button> 
          <Edit onSelected={selectedCellParams} open={openEdit} onClose={() => setOpenEdit(false)} onSuccess={handleEditSuccess}/> 
          </>
            
         )
        }
        {isAdmin && false && (  <Button color="primary" startIcon={<DeleteIcon />}
          onClick={handleDelete}
          onMouseDown={handleMouseDown}
          disabled={!selectedCellParams}
        
        >
          {cellMode === 'edit' ? 'Delete' : 'Delete'}
        </Button>
        )}

        <Grid item>
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    placeholder="Search"
                                    value={searchQuery}
                                    onChange={(e) => handleSearch(e.target.value)} // Call the search function
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <IconButton>
                                                    <Search />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    sx={{ 
                                    width: '1000px', // Set the desired width here
                                    marginTop: "10px",                  
                                    marginBottom: "10px", 
                                    marginLeft: "2px",
                                    marginRight: "2px",
                                      backgroundColor: '#ffffff',
                                      '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                          borderColor: '#00308F',
                                        },
                                        '&:hover fieldset': {
                                          borderColor: '#00207E',
                                        },
                                      },
                                    }}
                                />
                            </Grid>

        {/* <GridToolbarExport/> */}
        <Button 
          onClick={handleExport} 
          startIcon={<SaveAltIcon />} // Add the icon here
        >
          Export
        </Button>

                                    <Grid item>
                                      <IconButton
                                        onClick={() => window.location.reload()} // Refresh the page
                                        color="primary"
                                        sx={{
                                          backgroundColor: '#ffffff',
                                          '&:hover': {
                                            backgroundColor: '#f0f0f0',
                                          },
                                        }}
                                      >
                                        <Refresh />
                                      </IconButton>
                                    </Grid>
    
    </GridToolbarContainer>
  );
}
const FullFeaturedCrudGrid = () => {

  const [selectedCellParams, setSelectedCellParams] = React.useState(null);
  const [cellModesModel, setCellModesModel] = React.useState({});
  const user = useSelector((state) => state.user);
  // const [isAdmin, setIsAdmin] = useState(user?.role === 'Maintenance Admin' ? true : false);
  const [isAdmin, setIsAdmin] = useState(() => {
    if (!user || !user.department) return false; // Handle case where user or department is undefined
    const role = user.role?.toLowerCase();
    const department = user.department?.toLowerCase();
    // Check if user is Admin and department does not include Store or Supply or Others
    const isAdminRole = role === 'admin' && !department.includes('store') && !department.includes('supply') && !department.includes('others');
    
    // Check if user is Super Admin
    const isSuperAdminRole = role === 'super admin';
    return isAdminRole || isSuperAdminRole;
  });

  const handleCellFocus = React.useCallback((event) => {
    const row = event.currentTarget.parentElement;
    const dataId = row.dataset.id;
    const id = row.dataset.rowindex;
    const field = event.currentTarget.dataset.field;
    setSelectedCellParams({ id, field , dataId });
 
  }, []);

  const cellMode = React.useMemo(() => {
    if (!selectedCellParams) {
      return 'view';
    }
    const { id, field } = selectedCellParams;
    return cellModesModel[id]?.[field]?.mode || 'view';
  }, [cellModesModel, selectedCellParams]);

  const handleCellKeyDown = React.useCallback(
    (params, event) => {
      if (cellMode === 'edit') {
        // Prevents calling event.preventDefault() if Tab is pressed on a cell in edit mode
        event.defaultMuiPrevented = true;
      }
    },
    [cellMode],
  );

  const handleCellEditStop = React.useCallback((params, event) => {
    event.defaultMuiPrevented = true;
  }, []);


  // const [rows, setRows] = React.useState(initialRows);
  const [searchQuery, setSearchQuery] = useState('');
    const [rows, setRows] = useState(initialRows); // Initialize with initialRows
    const [filteredData, setFilteredData] = useState(rows); // Initialize with the original rows
  const [refreshTrigger, setRefreshTrigger] = React.useState(false);
  
  const [rowModesModel, setRowModesModel] = React.useState({});

  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
  
  const navigate = useNavigate();

  // console.log(rows);

  const handleSearch = (query) => {
        setSearchQuery(query);
        const filtered = rows.filter((row) => {
            return Object.values(row).some((field) =>
                field && field.toString().toLowerCase().includes(query.toLowerCase())
            );
        });
        setFilteredData(filtered);
    };
    const handleRefresh = () => {
        setSearchQuery('');
        getRowsFromDB(); // Call the function to fetch data from the server
    };

  const getRowsFromDB = async () => {
    try 
    {  
      const maintenanceResponse = await fetch(`${process.env.REACT_APP_MISBACKEND_URL}/maintenance`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
     
      });
      const records = await maintenanceResponse.json();
   
      // setRows(Object.keys(records).map((key) => records[key]));
      const processedData = Object.keys(records).map((key) => records[key]);
      // setRows(processedData);
      // setFilteredData(processedData); // Initialize filtered data 
      const sortedData = processedData.sort((a, b) => {
      return new Date(b.AssignDate) - new Date(a.AssignDate); // Sort in descending order
      });
      setRows(sortedData);
      setFilteredData(sortedData); // Initialize filtered data

    } catch (error) {
      
      console.log(error);
    }
  };

  React.useEffect(() => {
    getRowsFromDB();
  }, []);

  React.useEffect(() => {
    getRowsFromDB();
  }, [refreshTrigger]);

 

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const onRowsSelectionHandler = (ids) => {
    
    navigate(`../edit/${ids}`, { replace: true })
  };
  
  

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleDeleteClick = (id) => () => {
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  // console.log("Rows to export:", rows);

  const handleAddSuccess = () => {
    setRefreshTrigger(prev => !prev);
  }

  const handleEditSuccess = () => {
    setRefreshTrigger(prev => !prev);
    setRowSelectionModel([]);   
  }

  //Export Function
  const handleExport = async () => {
    // console.log("Exporting to Excel..."); // Log to check if the function is called
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Maintenance Records');
  
    // Add header rows
    const titleRow = worksheet.addRow(['ARYAN EXPORTERS PVT. LTD.']); // Change to your company name
    worksheet.mergeCells(`A1:L1`); // Adjust the range based on the number of columns
    titleRow.alignment = { horizontal: 'center', vertical: 'middle' };
    const mergedTitleCell = worksheet.getCell('A1');
    mergedTitleCell.font = { bold: true, size: 11 };
  
    // Add summary row
    const summaryRow = worksheet.addRow(['Summary of Maintenance Records']);
    worksheet.mergeCells(`A2:L2`); // Adjust the range based on the number of columns
    summaryRow.alignment = { horizontal: 'center', vertical: 'middle' };
    const mergedSummaryCell = worksheet.getCell('A2');
    mergedSummaryCell.font = { bold: true, size: 11 };
  
    // Add headers
    const excelHeaders = [
      'S/N', // Change from 'Id' to 'S/N'
      'Assign Date',
      'Work Type',
      'Department',
      'Machine',
      'Start Date',
      'Complete Date',
      'Description',
      'Comments',
      'Slip No',
      'Remarks',
      'Assigned To',
    ];
    worksheet.addRow(excelHeaders).font = { bold: true, size: 10 };
  
    // Sort rows in descending order based on id
    const sortedRows = [...rows].sort((a, b) => b.id - a.id); // Sort by id in descending order
  
    // Add data rows
    sortedRows.forEach((row, index) => {
      const dataRow = worksheet.addRow([
        index + 1,
        row.AssignDate || '', // Ensure empty values are handled
        row.WorkType || '',
        row.Department || '',
        row.Machine || '',
        row.StartDate || '',
        row.CompleteDate || '',
        row.MainDesc || '',
        row.Comments || '',
        row.SlipNo || '',
        row.Remarks || '',
        row.AssignedTo || ''
    ]);

    // Set font size for data rows
    dataRow.font = { size: 9 }; // Set the desired font size for data rows
  });
  
    // Apply styles to the worksheet
    worksheet.eachRow((row, rowNumber) => {
      row.eachCell((cell) => {
        cell.border = {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' },
        };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      });
  
      // Bold for header row
      if (rowNumber === 3) { // Header row is the third row after title and summary
        row.font = { bold: true };
      }
    });
  
    // Set column widths
    worksheet.getColumn(1).width = 5;   // S/N
    worksheet.getColumn(2).width = 10;  // Assign Date
    worksheet.getColumn(3).width = 18;  // Work Type
    worksheet.getColumn(4).width = 20;  // Department
    worksheet.getColumn(5).width = 18;  // Machine
    worksheet.getColumn(6).width = 17;  // Start Date
    worksheet.getColumn(7).width = 17;  // Complete Date
    worksheet.getColumn(8).width = 38;  // Description
    worksheet.getColumn(9).width = 25;  // Comments
    worksheet.getColumn(10).width = 18; // Slip No
    worksheet.getColumn(11).width = 8; // Remarks
    worksheet.getColumn(12).width = 12; // Assigned To
  
    // Save the workbook
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/octet-stream' });
    saveAs(blob, 'MaintenanceRecords.xlsx');
    // console.log("File downloaded successfully."); // Log to confirm download
  };

  const columns = [
    {
      field: 'id',
      headerName: 'id',     
      hideable: true,
      width: 80,
    },
    {
      field: 'AssignDate',
      headerName: 'Assign date',
      type: 'date',
      width: 90,
      valueFormatter: params => params?.value && new Date(params?.value).toLocaleDateString(), // For display
    },
    {
      field: 'WorkType',
      headerName: 'Work Type',
      width: 140,
      type: 'singleSelect',
      valueOptions: ['New Work', 'Electrical Maintenance', 'Machine Maintenance'],
    },

    {
      field: 'WorkSubType',
      headerName: 'Work Sub Type',
      width: 130,
    },
    
    { field: 'Department', headerName: 'Department', width: 140},
    { field: 'Machine', headerName: 'Machine', width: 110},
   
    {
      field: 'StartDate',
      headerName: 'Start date',
      type: 'date',
      width: 90,
      valueFormatter: params => params?.value && new Date(params?.value).toLocaleDateString(), // For display   
    },
    {
      field: 'CompleteDate',
      headerName: 'Complete date',
      type: 'date',
      width: 90,
      valueFormatter: params => params?.value && new Date(params?.value).toLocaleDateString(), // For display
    },    
    { field: 'MainDesc', headerName: 'Description', width: 110},
    { field: 'Comments', headerName: 'Comments', width: 110},
    {
        field: 'SlipNo',
        headerName: 'Slip No',
        type: 'number',
        width: 50,
        align: 'left',
        headerAlign: 'left',
      },
    { field: 'Remarks', headerName: 'Remarks', width: 90},
    { field: 'AssignedTo', headerName: 'Assigned To', width: 90},
    
   
  ];

  return (
    <Box
      sx={{
        height: 600,
        width: '95%',
        marginLeft:"180px",
        paddingRight:"90px"
      }}
    > 
      <DataGrid
        // rows={rows.slice(0).sort((a,b)=>
        // a.AssignDate.localeCompare(b.AssignDate)).reverse()}
         rows={filteredData} // Use filteredData here
        initialState={{
        
          columns: {
            
            columnVisibilityModel: {
              id: false,
            },
          },
        }}
        columns={columns}
        checkboxSelection 
        disableMultipleRowSelection
        sx={{
            boxShadow: 1,
            border: 1,
            borderColor: 'primary.light',
            typography: 'subtitle2',
            '& .MuiDataGrid-cell:hover': {
              color: 'primary.main',
            },
            '.MuiDataGrid-columnHeaderTitle': { 
                font: 'light important',
                overflow: 'visible !important'
             }
          }}
        
        onCellKeyDown={handleCellKeyDown}
        cellModesModel={cellModesModel}
        onCellEditStop={handleCellEditStop}
        onCellModesModelChange={(model) => setCellModesModel(model)}
        rowSelectionModel={rowSelectionModel}
        onRowSelectionModelChange={setRowSelectionModel} 
        slots={{
            toolbar: EditToolbar           
          }}
        slotProps={{
            toolbar: {
              cellMode,
              selectedCellParams,
              setSelectedCellParams,
              cellModesModel,
              setCellModesModel,
              handleExport,
              handleAddSuccess,
              handleEditSuccess,
              data: rows, // Pass the rows to the toolbar
              setFilteredData, // Pass the setter for filtered data
              handleRefresh, // Pass the refresh function
            },
            cell: {
              onFocus: handleCellFocus,
            },
        }}
      />
    </Box>
  );
}
export default FullFeaturedCrudGrid;